/**
 * 登录态失效的统一处理。
 *
 * 各 api 模块原本各写一份：
 *   if (code == 250004 || code == 250011) { localStorage.clear(); location.reload() }
 *
 * 这个写法在「本来就没登录」时会无限刷新：
 *   未登录访问 → 接口返回 250004 → 清空并刷新 → 刷新后依然没 token
 *   → 页面再次请求 → 又是 250004 → 又刷新 …
 * 手机端因为允许游客浏览背诵，点到题库就能稳定复现。
 *
 * 现在的规则：
 *   1. 永不 reload。刷新解决不了「没登录」，只会转圈
 *   2. 只有本地确实存着 token（说明是 token 过期/失效）才清理登录态
 *   3. 只清认证相关的键，不 clear() 整个 localStorage ——
 *      那会顺手删掉 viewMode 等无关设置，把用户从电脑版弹回手机版
 *   4. 业务码原样返回，由页面自己决定提示「请先登录」还是别的
 */

// 登录态相关的 localStorage 键，和 Mine.vue 的退出登录保持一致
const AUTH_KEYS = [
  'token', 'id', 'username', 'head_img', 'phone',
  'slogan', 'role', 'realName', 'idcard'
]

/** 业务码是否表示未登录 / token 失效 */
export function isNotLogin(res) {
  if (!res) return false
  // 后端这两个码都用过，且历史代码是 == 比较（可能返回字符串），这里保持宽松比较
  /* eslint-disable eqeqeq */
  return res.code == 250004 || res.code == 250011
  /* eslint-enable eqeqeq */
}

/** 清掉登录态，但保留其他本地设置 */
export function clearAuth() {
  AUTH_KEYS.forEach(k => {
    try {
      localStorage.removeItem(k)
    } catch (e) {
      // 隐私模式下可能抛异常，忽略
    }
  })
}

/**
 * 响应拦截器里调用。命中未登录时做必要的清理，但不跳转、不刷新。
 * @param {Object} res 接口返回体
 * @returns {boolean} 是否命中未登录
 */
export function handleAuthFailure(res) {
  if (!isNotLogin(res)) return false

  let hadToken = false
  try {
    hadToken = !!localStorage.getItem('token')
  } catch (e) {
    hadToken = false
  }

  // 本地有 token 却被判未登录 = token 失效，清掉避免后续请求继续带着它
  if (hadToken) clearAuth()

  return true
}



// WEBPACK FOOTER //
// ./src/utils/api/auth-fallback.js